<template lang="pug">
form.columns.align-center.my-2(@submit.prevent="onFilter")
  .pb-1.column.col-auto(v-if="isEnabledFilter('numero_eq')")
    small {{ filters.numero_eq }}
    int.form-input.input-sm(
      :placeholder="filters.numero_eq",
      v-model="q.numero_eq"
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('ano_eq')")
    small {{ filters.ano_eq }}
    year.form-input.input-sm(:placeholder="filters.ano_eq", v-model="q.ano_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('cadastro_id_eq')")
    small {{ filters.cadastro_id_eq }}
    cadastro-picker(v-model="q.cadastro_id_eq", sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('local_cadastro_id_eq')")
    small {{ filters.local_cadastro_id_eq }}
    cadastro-picker(v-model="q.local_cadastro_id_eq", sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('pessoas_cpf_cnpj_eq')")
    small {{ filters.pessoas_cpf_cnpj_eq }}
    input-cpf-cnpj.form-input.input-sm(v-model="q.pessoas_cpf_cnpj_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('created_at_gteq')")
    small {{ filters.created_at_gteq }}
    datepicker(
      v-model="q.created_at_gteq",
      :placeholder="filters.created_at_gteq",
      input-class="form-input input-sm"
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('created_at_lteq')")
    small {{ filters.created_at_lteq }}
    datepicker(
      v-model="q.created_at_lteq",
      :placeholder="filters.created_at_lteq",
      input-class="form-input input-sm",
      full-day
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('modelo_id_eq')")
    small {{ filters.modelo_id_eq }}
    doc-modelo-picker(v-model="q.modelo_id_eq", sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('ciencia_em_gteq')")
    small {{ filters.ciencia_em_gteq }}
    datepicker(
      v-model="q.ciencia_em_gteq",
      :placeholder="filters.ciencia_em_gteq",
      input-class="form-input input-sm"
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('ciencia_em_lteq')")
    small {{ filters.ciencia_em_lteq }}
    datepicker(
      v-model="q.ciencia_em_lteq",
      :placeholder="filters.ciencia_em_lteq",
      input-class="form-input input-sm"
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('autuado_em_gteq')")
    small {{ filters.autuado_em_gteq }}
    datepicker(
      v-model="q.autuado_em_gteq",
      :placeholder="filters.autuado_em_gteq",
      input-class="form-input input-sm"
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('autuado_em_lteq')")
    small {{ filters.autuado_em_lteq }}
    datepicker(
      v-model="q.autuado_em_lteq",
      :placeholder="filters.autuado_em_lteq",
      input-class="form-input input-sm",
      full-day
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('updated_at_gteq')")
    small {{ filters.updated_at_gteq }}
    datepicker(
      v-model="q.updated_at_gteq",
      :placeholder="filters.updated_at_gteq",
      input-class="form-input input-sm"
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('updated_at_lteq')")
    small {{ filters.updated_at_lteq }}
    datepicker(
      v-model="q.updated_at_lteq",
      :placeholder="filters.updated_at_lteq",
      input-class="form-input input-sm",
      full-day
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('debito_vence_em_gteq')")
    small {{ filters.debito_vence_em_gteq }}
    datepicker(
      v-model="q.debito_vence_em_gteq",
      :placeholder="filters.debito_vence_em_gteq",
      input-class="form-input input-sm"
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('debito_vence_em_lteq')")
    small {{ filters.debito_vence_em_lteq }}
    datepicker(
      v-model="q.debito_vence_em_lteq",
      :placeholder="filters.debito_vence_em_gteq",
      input-class="form-input input-sm",
      full-day
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('debito_vencido')")
    small {{ filters.debito_vencido }}
    select.form-select.select-sm(v-model="debitoVencido")
      option(value="*-*") todos
      option(value="1-*") todos vencidos
      option(value="1-10") até 10 dias
      option(value="11-20") de 11 a 20 dias
      option(value="16-30") de 15 a 30 dias
      option(value="31-45") de 31 a 45 dias
      option(value="46-60") de 46 a 60 dias
      option(value="61-90") de 61 a 90 dias
      option(value="91-*") acima de 90 dias
  .pb-1.column.col-auto(v-if="isEnabledFilter('fiscal_id_eq')")
    small {{ filters.fiscal_id_eq }}
    fiscal-picker(v-model="q.fiscal_id_eq", sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('cadastro_zona_eq')")
    small {{ filters.cadastro_zona_eq }}
    input.form-input.input-sm(
      type="tel",
      :placeholder="filters.cadastro_zona_eq",
      v-model="q.cadastro_zona_eq"
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('cadastro_quadra_eq')")
    small {{ filters.cadastro_quadra_eq }}
    input.form-input.input-sm(
      type="tel",
      :placeholder="filters.cadastro_quadra_eq",
      v-model="q.cadastro_quadra_eq"
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('cadastro_lote_eq')")
    small {{ filters.cadastro_lote_eq }}
    input.form-input.input-sm(
      type="tel",
      :placeholder="filters.cadastro_lote_eq",
      v-model="q.cadastro_lote_eq"
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('fiscal.usuario_grupo_id_in')")
    small {{ filters["fiscal.usuario_grupo_id_in"] }}
    usuario-grupos-picker(v-model="q['fiscal.usuario_grupo_id_in']", sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('situacao_id_eq')")
    small {{ filters.situacao_id_eq }}
    doc-situacao-picker(v-model="q.situacao_id_eq", sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('comentario_situacao_id_eq')")
    small {{ filters.comentario_situacao_id_eq }}
    comentario-situacao-picker(v-model="q.comentario_situacao_id_eq", sm)
  .pb-1.column.col-auto(
    v-if="isEnabledFilter('comentarios.comentario_situacao_id_eq')"
  )
    small {{ filters["comentarios.comentario_situacao_id_eq"] }}
    comentario-situacao-picker(
      v-model="q['comentarios.comentario_situacao_id_eq']",
      sm
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('existe_senha_web_eq')")
    small {{ filters.existe_senha_web_eq }}
    select.form-select.select-sm(v-model="q.existe_senha_web_eq")
      option(:value="undefined") Todos
      option(:value="true") Sim
      option(:value="false") Não
  .pb-1.column.col-auto(
    v-if="isEnabledFilter('irregularidades_descricao_cont')"
  )
    small {{ filters.irregularidades_descricao_cont }}
    input.form-input.input-sm(v-model="q.irregularidades_descricao_cont")
  .pb-1.column.col-auto(v-if="isEnabledFilter('regularizar_em_vencimento')")
    small {{ filters.regularizar_em_vencimento }}
    select.form-select.select-sm(v-model="regularizar_em_vencimento")
      option(value="") Todos
      option(value="vencido") Vencido
      option(value="a_vencer") À vencer
  .pb-1.column.col-auto(v-if="isEnabledFilter('reincidente_eq')")
    small {{ filters.reincidente_eq }}
    int.form-input.input-sm(
      :placeholder="filters.reincidente_eq",
      v-model="q.reincidente_eq"
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('tipo_eq')")
    small {{ filters.tipo_eq }}
    doc-tipo-select.form-select.select-sm(v-model="q.tipo_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('tipo_entrega_eq')")
    small {{ filters.tipo_entrega_eq }}
    select-doc-ciencia-tipo.form-select.select-sm(v-model="q.tipo_entrega_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('autor_id_eq')")
    small {{ filters.autor_id_eq }}
    fiscal-picker(v-model="q.autor_id_eq", sm)
  .column.col-auto.pb-1
    small Ordenar por
    order-by(:fields="orderByFields", :query="q", sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('cadastro.cadastro_imobiliario.imovel_tipo_eq')")
    small {{ filters['cadastro.cadastro_imobiliario.imovel_tipo_eq'] }}
    select.form-select.select-sm(v-model="q['cadastro.cadastro_imobiliario.imovel_tipo_eq']")
      option(value="") Todos
      option(value="P") Predial
      option(value="T") Territorial
  .column.col-auto
    .label-padding-top.d-flex
      button.btn.btn-link.tooltip.tooltip-bottom(
        type="submit",
        data-tooltip="Filtrar",
        :disabled="$v.q.$invalid"
      )
        i.fa.fa-search.fa-lg
      enabled-filters(
        :localStorageKey="filterKey",
        :defaultEnabledFilters="defaultEnabledFilters",
        :enabledFilters="enabledFilters",
        :filters="filters",
        :query="q",
        :setEnabledFilters="setEnabledFilters"
      )
      a.btn.btn-link.btn-sm.no-print.tooltip.tooltip-bottom(
        data-tooltip="Imprimir",
        onclick="window.print()"
      )
        i.fa.fa-lg.fa-print
      slot(name="additionalButtons")
</template>

<script>
import filterMixin from "@/mixins/filter"

export default {
  mixins: [filterMixin],
  props: {
    filterKey: { type: String, default: "docs_enabled_filters" },
    autoFilter: { type: Boolean, default: false },
    defaultQuery: { type: Object, default: () => {} },
  },
  data() {
    return {
      tmpDebitoVencido: "*-*",
      tmpRegularizarEmVencimento: "",
      filters: {
        numero_eq: this.$options.filters.tModel("doc.numero"),
        ano_eq: this.$options.filters.tModel("doc.ano"),
        cadastro_id_eq: "Cadastro",
        local_cadastro_id_eq: "Cadastro do local",
        created_at_gteq: "Emissão início",
        created_at_lteq: "Emissão fim",
        ciencia_em_gteq: "Ciência início",
        ciencia_em_lteq: "Ciência fim",
        autuado_em_gteq: "Autuação início",
        autuado_em_lteq: "Autuação fim",
        updated_at_gteq: "Doc Alteração início",
        updated_at_lteq: "Doc Alteração fim",
        debito_vence_em_gteq: "Vcto débito início",
        debito_vence_em_lteq: "Vcto débito fim",
        debito_vencido: "Débito vencido",
        pessoas_cpf_cnpj_eq: this.$options.filters.tModel(
          "contribuinte.cpf_cnpj",
        ),
        cadastro_zona_eq: this.$options.filters.tModel("cadastro.zona"),
        cadastro_quadra_eq: this.$options.filters.tModel("cadastro.quadra"),
        cadastro_lote_eq: this.$options.filters.tModel("cadastro.lote"),
        "fiscal.usuario_grupo_id_in": "Grupos de usuário",
        fiscal_id_eq: this.$options.filters.tModel("doc.fiscal"),
        situacao_id_eq: this.$options.filters.tModel("doc.situacao"),
        comentario_situacao_id_eq: this.$options.filters.tModel(
          "doc.comentario_situacao",
        ),
        "comentarios.comentario_situacao_id_eq":
          "Contém comentário com situação",
        existe_senha_web_eq: this.$options.filters.tModel(
          "doc.existe_senha_web",
        ),
        regularizar_em_vencimento: "Prazo regularizar",
        modelo_id_eq: this.$options.filters.tModel("doc.modelo"),
        irregularidades_descricao_cont: "Descrição da irregularidade",
        reincidente_eq: "Reincidência",
        tipo_eq: "Tipo de documento",
        tipo_entrega_eq: this.$options.filters.tModel("doc.tipo_entrega"),
        autor_id_eq: this.$options.filters.tModel("doc.autor"),
        "cadastro.cadastro_imobiliario.imovel_tipo_eq": this.$options.filters.tModel(
          "cadastro.cadastro_imobiliario.imovel_tipo",
        ),
      },
      defaultEnabledFilters: ["numero_eq", "ano_eq"],
      orderByFields: {
        numero: this.$options.filters.tModel("doc.numero"),
        ano: this.$options.filters.tModel("doc.ano"),
        valor_total: this.$options.filters.tModel("doc.valor_total"),
        cadastro_numero: this.$options.filters.tModel("cadastro"),
        created_at: this.$options.filters.tModel("doc.created_at"),
        ciencia_em: this.$options.filters.tModel("doc.ciencia_em"),
        autuado_em: this.$options.filters.tModel("doc.autuado_em"),
        debito_vence_em: this.$options.filters.tModel("doc.debito_vence_em"),
        cadastro_zona: this.$options.filters.tModel("cadastro.zona"),
        cadastro_quadra: this.$options.filters.tModel("cadastro.quadra"),
        cadastro_lote: this.$options.filters.tModel("cadastro.lote"),
        fiscal_nome: this.$options.filters.tModel("doc.fiscal"),
      },
    }
  },
  validations: {
    q: {},
  },
  computed: {
    regularizar_em_vencimento: {
      get() {
        return this.tmpRegularizarEmVencimento
      },
      set(value) {
        this.tmpRegularizarEmVencimento = value
        this.$set(
          this.q,
          "regularizar_em_lt",
          value === "vencido" ? "now" : undefined,
        )
        this.$set(
          this.q,
          "regularizar_em_gt",
          value === "a_vencer" ? "now" : undefined,
        )
      },
    },
    debitoVencido: {
      get() {
        return this.tmpDebitoVencido
      },
      set(v) {
        this.tmpDebitoVencido = v
        const [de, ate] = v.split("-")
        const lteq = this.subDate(de)
        const gteq = this.subDate(ate)
        this.$set(this.q, "debito_vence_em_gteq", gteq)
        this.$set(this.q, "debito_vence_em_lteq", lteq)
      },
    },
  },

  methods: {
    subDate(days) {
      if (days === "*") return null
      const d = new Date()
      const date = new Date(
        d.getFullYear(),
        d.getMonth(),
        d.getDate() - Number(days),
        0,
        0,
        0,
        0,
      )

      return date.toJSON()
    },

    onFilter() {
      this.$emit("submit", this.q)
    },
  },

  created() {
    this.q = { ...this.defaultQuery }
    if (this.autoFilter) {
      this.onFilter()
    }
  },
}
</script>

<style lang="stylus" scoped>
.mx-datepicker {
  padding: 0;
}
</style>
